import { render } from "./MfSubmitalPublic.vue?vue&type=template&id=8990ea22"
import script from "./MfSubmitalPublic.vue?vue&type=script&lang=js"
export * from "./MfSubmitalPublic.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__